import { render, staticRenderFns } from "./GerenciarEmendasEstaduais.vue?vue&type=template&id=7a8a1efc&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarEmendasEstaduais.vue?vue&type=style&index=0&id=7a8a1efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8a1efc",
  null
  
)

export default component.exports